import styled, { css } from 'styled-components'

import {
    customScrollBar,
    FlexCentered,
    FullWidthHeight,
} from 'components/common/genericStyles'

const artefactWidth = 75 // %
const participantsWidth = 100 - artefactWidth // %

const teacherHeight = 35 // %
const studentsHeight = 100 - teacherHeight // %

export const Container = styled.div`
    ${FullWidthHeight}
    display: flex;
`

export const ArtefactWrapper = styled.div`
    width: ${artefactWidth}%;
    height: 100%;
    ${FlexCentered}
`

export const Participants = {
    Container: styled.div`
        width: ${participantsWidth}%;
        height: 100%;
        padding: 10px;
    `,
    Teacher: styled.div`
        width: 100%;
        height: ${teacherHeight}%;
        position: relative;
    `,
    Students: styled.div`
        width: 100%;
        height: ${studentsHeight}%;
        overflow: hidden auto;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        ${customScrollBar}
    `,
}

export const studentOverrides = {
    area: css`
        padding-top: 50%;
        width: 50%;
    `,
    wrapper: css`
        width: 95%;
        height: 95%;
    `,
}
